import styled from "styled-components";

export const DualRangeSliderStyles = styled.div`
  width: 100%;
  padding: 8px 0;

  .sliderWrapper {
    padding: 0 4px;

    .rc-slider {
      height: 20px;
      padding: 6px 0;
    }

    .rc-slider-rail {
      height: 8px;
      border-radius: 4px;
      background: ${({ theme }) => theme.colors.primary[100]};
    }

    .rc-slider-track {
      height: 8px;
      border-radius: 4px;
      background: ${({ theme }) => theme.colors.semantic.accent.default};
    }

    .rc-slider-handle {
      width: 26px;
      height: 26px;
      margin-top: -9px;
      border: 3px solid ${({ theme }) => theme.colors.semantic.container.white};
      background: ${({ theme }) => theme.colors.semantic.accent.default};
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      opacity: 1;
      cursor: pointer;
      transition: box-shadow 0.15s ease, transform 0.15s ease;

      &:hover {
        box-shadow: 0 3px 12px rgba(124, 58, 237, 0.4);
        border-color: ${({ theme }) => theme.colors.semantic.container.white};
      }

      &:active,
      &.rc-slider-handle-dragging {
        box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.2);
        border-color: ${({ theme }) => theme.colors.semantic.container.white};
      }

      &:focus-visible {
        box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.25);
        border-color: ${({ theme }) => theme.colors.semantic.container.white};
      }
    }
  }

  .valuesDisplay {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[16]};
    margin-top: ${({ theme }) => theme.spacing[12]};
  }

  .valueBadge {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[8]};
    background: ${({ theme }) => theme.colors.accent[50]};
    border: 1px solid ${({ theme }) => theme.colors.accent[150]};
    border-radius: ${({ theme }) => theme.radius[8]};
    padding: 6px 14px;
  }

  .valueBadge .badgeLabel {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .valueBadge .badgeAmount {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.semantic.accent.default};
  }

  .valueDash {
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .rangeLabels {
    display: flex;
    justify-content: space-between;
    margin-top: ${({ theme }) => theme.spacing[4]};
  }

  .rangeLabels span {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.placeholder};
  }
`;
